import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { Table, Button, Form, Pagination } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { getDownloadDataExcel, postData } from "../../../../utils/api";
import { Link } from "react-router-dom";
import "./PendingOrdersTable.css";
import {
  calculateTimeAgo,
  formatDateToIST,
  formatTimeInIST,
  IDS,
  OrderStatusIds,
  ReturnStatusIds,
  RoleId,
  ServiceIds,
} from "../../../../utils/common";
import ProductModal from "../ProductModal";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
// import AssignOffCanvance from "../AssignDeliveryBoy";
// import ProductModal from "../ProductModal";
// import AssignReturnOffCanvance from "../AssignReturnDeliveryBoy";

import DatePicker from "react-datepicker";
import search1 from "../../../assets/icons/search.png";
import dayjs from "dayjs";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RemarkModal from "../../../common/RemarkModal";
import ModalSave from "../../../common/ModelSave";
function PendingOrdersTable({
  user,
  OrderByOptions,
  resultsPerPageOptions,
  storeCategories,
  vendorServices,
  GetAllCounts,
  activeTab,
}) {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
  } = useContext(Context);

  const [perPage, setperPage] = useState({
    value: 10,
    label: "Results per page: 10",
  });

  const [sortOrder, setSortOrder] = useState({
    value: "DESC",
    label: "Sort-by date (Descending)",
  });

  const [data, setData] = useState([]);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [search, setSearch] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchCustomerContact, setSearchCustomerContact] = useState("");
  const [reset, setReset] = useState();
  const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [option, setOption] = useState();
  const [hideFilter, setHideFilter] = useState(false);
  const [storeCategory, setStoreCategory] = useState("");
  const [productCategory, setProductCategory] = useState("");

  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const [searchStartTime, setSearchStartTime] = useState();
  const [searchEndTime, setSearchEndTime] = useState();
  const [loading, setLoading] = useState(false);
  const [searchInvoice, setSearchInvoice] = useState("");

  const [showModal2, setShowModal2] = useState({
    code: 0,
    message: "",
  });

  const getDataAll = async () => {
    setLoading(true);
    const response = await getData(
      `/admin/orders/product-order?page=${onPageChange || 1}&per_page=${
        perPage?.value || 10
      }&term=${search}&searchOrderStatus=${
        OrderStatusIds.Pending || ""
      }&storeCategory=${storeCategory}&productCategory=${
        productCategory.value || ""
      }&sortOrder=${sortOrder?.value || "DESC"}&from=${
        searchDateFrom || ""
      }&searchInvoice=${searchInvoice || ""}&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
        searchEndTime || ""
      }&name=${search || ""}&customer=${searchCustomer || ""}&customer_contact=${searchCustomerContact || ""}`,
    );
    await setData(response);
    if (response?.success) {
      setLoading(false);
    }
    setCurrentPage(response?.data?.current_page);
    setperPage(response?.data?.per_page);
    settotalPages(response?.data?.total_pages);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    // await GetAllCounts();
  };
  useEffect(() => {
    getDataAll();
  }, [reset, searchOrderStatus, onPageChange, activeTab]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const [showAssign, setShowAssign] = useState({ show: 0, data: {} });
  const [showReturnAssign, setShowReturnAssign] = useState({
    show: 0,
    data: {},
  });
  const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "20px",
      borderColor: "#ddd",
      boxShadow: "none",
      fontSize: "15px",
      "&:hover": {
        borderColor: "#aaa",
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#000",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: "#eee",
      },
    }),
  };

  const ChangeOrderStatus = async (id, status_id) => {
    try {
      // Send the POST request to update the store's status
      const response = await postData(
        `/admin/orders/product-order/update-status/${id}`,
        {
          order_status_id: status_id,
        },
      );
      if (response?.success) {
        await setShowModal2({ code: response.code, message: response.data });
      } else {
        await setShowModal2({
          code: response?.code,
          message: response?.errors,
        });
      }
      setTimeout(() => {
        setShowModal2(0);
      }, 1000);
      // Refresh the data after updating the store's status
      await getDataAll();
      await GetAllCounts();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const handleRemarkSubmit = async (remark) => {
    const data = {
      order_status_id: OrderStatusIds.Rejected,
    };
    if (remark) {
      data.remark = remark;
    }
    const response = await postData(
      `/admin/orders/product-order/update-status/${selectedOrderId}`,
      data,
    );

    if (response?.success) {
      await setShowModal2({ code: response.code, message: response.data });
    } else {
      await setShowModal2({
        code: response?.code,
        message: response?.errors,
      });
    }
    setTimeout(() => {
      setShowModal2(0);
    }, 1000);

    setShowRemarkModal(false);
    await getDataAll();
    await GetAllCounts();
  };

  const downloadInvoice = async (invoiceUrl) => {
    try {
      const response = await fetch(invoiceUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "invoice.pdf"; // Set your preferred filename
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");
    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  // STATES
  const [selectOrders, setSelectOrders] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [bulkMessage, setBulkMessage] = useState("");

  // SINGLE USER SELECT
  const handleSelectUser = (id) => {
    setSelectOrders((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      }
      return [...prev, id];
    });
  };

  // SELECT ALL
  const handleSelectAll = (checked) => {
    setIsAllSelected(checked);
    if (!checked) {
      setSelectOrders([]);
    }
  };

  const handleUpdateOrder = async () => {
    try {
      setLoading(true);

      const finalData = new FormData();
      finalData.append("is_all", isAllSelected);
      finalData.append("order_ids", JSON.stringify(selectOrders));
      finalData.append("order_status_id", OrderStatusIds.Processing);
      const response = await postData(
        `/admin/orders/product-order/update-all?page=${onPageChange || 1}&per_page=${
          perPage?.value || 10
        }&term=${search}&searchOrderStatus=${
          OrderStatusIds.Pending || ""
        }&storeCategory=${storeCategory}&productCategory=${
          productCategory.value || ""
        }&sortOrder=${sortOrder?.value || "DESC"}&from=${
          searchDateFrom || ""
        }&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
          searchEndTime || ""
        }&name=${search || ""}&customer=${searchCustomer || ""}&customer_contact=${searchCustomerContact || ""}`,
        finalData,
      );

      if (response?.success) {
        await setShowModal2({ code: response.code, message: response.data });
      } else {
        await setShowModal2({
          code: response?.code,
          message: response?.errors,
        });
      }
      getDataAll();
      setSelectOrders([]);
      setIsAllSelected(false);
      setTimeout(() => {
        setBulkMessage("");
        setShowMessageModal(0);
        setShowModal2(0);
      }, 1000);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        const fileName = `Pending_Orders_${dayjs().format("DDMMMYYYY").toLowerCase()}`;

        await getDownloadDataExcel(
          `/admin/orders/download?page=${onPageChange || 1}&per_page=${
            perPage?.value || 10
          }&term=${search}&searchOrderStatus=${
            OrderStatusIds.Pending || ""
          }&storeCategory=${storeCategory}&productCategory=${
            productCategory.value || ""
          }&sortOrder=${sortOrder?.value || "DESC"}&from=${
            searchDateFrom || ""
          }&to=${searchDateTo || ""}&start_time=${
            searchStartTime || ""
          }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
            searchCustomer || ""
          }&is_all=${isAllSelected || ""}&order_ids=${JSON.stringify(selectOrders) || ""}`,
          null,
          fileName,
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <section className="pending-table_holder">
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row">
            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  min="0001-01-01"
                  max="9999-12-31"
                  value={searchDateFrom}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Check if year has 4 digits
                    if (year.length === 4 || value === "") {
                      setSearchDateFrom(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  min="0001-01-01"
                  max="9999-12-31"
                  value={searchDateTo}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Allow only if year is 4 digits or input is empty
                    if (year.length === 4 || value === "") {
                      setSearchDateTo(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row align-items-end mb-3">
        <div className="col-12 mb-2">
          <div className="row">
            <div className="col-lg-3 mb-2">
              <Form.Label>Select Product </Form.Label>
              <Select
                isSearchable
                options={product}
                value={productCategory}
                placeholder="Select Product"
                onChange={(e) => {
                  setProductCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div>
            <div className="col-lg-3 mb-2">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                placeholder="Enter Customer Name"
                type="text"
                className="form-control"
                id=""
                value={searchCustomer}
                onChange={(e) => {
                  setSearchCustomer(e.target.value);
                }}
              />
            </div>

            <div className="col-lg-3 mb-2">
              <Form.Label>Customer Contact No</Form.Label>
              <Form.Control
                placeholder="Enter Customer Contact No"
                type="text"
                className="form-control"
                id=""
                value={searchCustomerContact}
                onChange={(e) => {
                  setSearchCustomerContact(e.target.value);
                }}
              />
            </div>

            <div className="col-lg-3 mb-2">
              <Form.Label>Invoice No</Form.Label>
              <Form.Control
                placeholder="Enter Invoice No"
                type="text"
                className="form-control"
                id=""
                value={searchInvoice}
                onChange={(e) => {
                  setSearchInvoice(e.target.value);
                }}
              />
            </div>
            <div className="col-xxl-1 col-xl-1  col-lg-1 col-md-1 col-sm-2 col-3 1st">
              <div className="Search me-2">
                <Form.Label>Search</Form.Label>
                <Button
                  type="button"
                  onClick={getDataAll}
                  className="btn btn-search"
                >
                  <img src={search1} className="search" alt="" />
                </Button>
              </div>
            </div>
            <div className="col-xxl-1 col-xl-1  col-lg-1 col-md-2 col-sm-2 col-2 2nd">
              <div className="Search-1">
                <Form.Label>Reset</Form.Label>
                <br />
                <button
                  type="button"
                  onClick={() => {
                    setSearch("");
                    setSearchCustomerContact("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setSearchEndTime("");
                    setSearchStartTime("");
                    setSearchCustomer("");
                    setProductCategory("");
                    setSelectOrders([]);
                    setIsAllSelected(false);
                    setSearchInvoice("");
                    setIsAllSelected(false);
                    setSelectOrders([]);
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button>
              </div>
            </div>

            <div className=" col-xl-2 col-lg-4 col-md-2 col-sm-4 mb-2 3rd">
              <Form.Label> Download Excel</Form.Label>
              <div>
                <button
                  className="btn btn-success "
                  type="button"
                  // onClick={() => setShowMessageModal(true)}
                  onClick={HandleDownload}
                >
                  Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div>
            <div className=" col-xl-2 col-lg-4 col-md-4 col-sm-4 mb-2 4th">
              <Form.Label>Orders Acceptance</Form.Label>
              <div>
                <button
                  className="btn btn-success "
                  type="button"
                  disabled={!isAllSelected && !selectOrders.length}
                  onClick={handleUpdateOrder}
                >
                  Send Selected Orders to Accepted
                  <FontAwesomeIcon icon="fa-solid fa-check" className="ms-2" />
                </button>
              </div>
            </div>

            {/* <div className="col-md-3 mt-2">
              <label className="form-label">
                Accept All Orders
              </label>
              <button
                className="btn btn-success "
                type="button"
                disabled={
                  !isAllSelected &&
                  !selectOrders.length
                }

              >
                Accept All
                <FontAwesomeIcon
                  icon="fa-solid fa-comments"
                  className="ms-2"
                />
              </button>
            </div> */}
          </div>
        </div>
      </div>

      <div>
        <div className="total_div_text">
          <p className="inner_text">Total Order : </p>
          {data?.data?.total}
        </div>
        <div className="total_div_text">
          <p className="inner_text">Total Amount : </p> ₹
          {Number(data?.data?.total_selling_value || 0).toFixed(2)}
        </div>
        <div className="total_div_text">
          <p className="inner_text">Average Amount : </p> ₹
          {Number(data?.data?.average_selling_value || 0).toFixed(2)}
        </div>
        {/* <div>
          <strong>Total Kg:</strong>
          {Number(data?.data?.total_weight || 0).toFixed(2)} kg
        </div> */}
      </div>

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              <th style={{ width: "5%" }}>
                <Form.Check
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                />
              </th>
              <th>Order Date</th>
              <th>Order details</th>

              <th>Products</th>
              <th>Total</th>
              <th>Delivery Details</th>
              <th>Order Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="9" className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            ) : (
              data?.data?.data?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Form.Check
                      type="checkbox"
                      checked={isAllSelected || selectOrders.includes(item?.id)}
                      onChange={() => handleSelectUser(item?.id)}
                    />
                  </td>
                  <td className="order-date">
                    <div className="order-id">
                      {calculateTimeAgo(item?.createdAt)}
                    </div>
                    <div className="order-info">
                      <span>
                        {new Date(item?.createdAt).toISOString().split("T")[0]}
                      </span>
                    </div>
                    <div className="order-info">
                      <span>{formatTimeInIST(item?.createdAt)} IST</span>
                    </div>
                  </td>

                  {/* Owner Details */}
                  <td className="order-details">
                    <div className="order-id text-highlight">
                      {item?.invoice_no}
                    </div>
                    <div className="order-info">
                      <span>
                        <b>Buyer Name</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span className="text-highlight user-name-holder">
                        {item?.User?.name}
                      </span>
                    </div>
                    <div className="order-info">
                      <span className="order-info">
                        {item?.User?.contact_no}
                      </span>
                    </div>

                    <div className="order-info">
                      <span>{item?.Payment_Method?.name}</span>
                    </div>

                    {item?.razorpay_order_id && (
                      <div className="order-info">
                        <span>Payment ID : {item?.razorpay_order_id}</span>
                      </div>
                    )}
                  </td>

                  <td className="order-details">
                    {item?.Product_Order_Details?.map((product, index) => (
                      <div key={product?.id || index} className="mb-2">
                        <div className="text-highlight mt-2">
                          <b>{index + 1}.</b>{" "}
                          <span>
                            <b>Product Name</b>
                          </span>
                          : <span>{product?.Product?.name}</span>
                        </div>

                        {/* <div className="order-info ms-3">
                          <span>
                            <b>Category Name</b>
                          </span>
                          : <span>{product?.Product?.p_category?.name}</span>
                        </div> */}
                      </div>
                    ))}
                    <div></div>
                    <div className=" mt-3">
                      <Button
                        className="action-btn active"
                        onClick={() =>
                          setShowDetails({
                            show: item?.id,
                            data: item?.Product_Order_Details,
                          })
                        }
                      >
                        View All Details
                      </Button>
                    </div>
                  </td>

                  <td className="order-details">
                    <div className="order-id">
                      <span>
                        <b className="user-name-holder">Total SubTotal</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}
                        {Number(item?.total_selling_price).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Packing Charges</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.packing_charges} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b className="user-name-holder">Delivery Charges</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}
                        {Number(item?.delivery_charges).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Offer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.total_offer_discount} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b className="user-name-holder">Coupon Discount</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}
                        {Number(item?.total_coupon_discount).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Refer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.refer_discount} /-</span>
                  </div> */}
                    {Number(item?.total_cashback_amount) > 0 && (
                      <>
                        <div className="order-id">
                          <span>
                            <b className="user-name-holder">Total Cashback</b>
                          </span>
                        </div>
                        <div className="order-info">
                          <span>
                            {" "}
                            {item.Exchange_Rate?.symbol || "₹"}
                            {Number(item?.total_cashback_amount).toFixed(2)} /-
                          </span>
                        </div>
                      </>
                    )}
                    {Number(item?.total_tax) > 0 && (
                      <>
                        <div className="order-id">
                          <span>
                            <b className="user-name-holder">Total Tax</b>
                          </span>
                        </div>
                        <div className="order-info">
                          <span>
                            {" "}
                            {item.Exchange_Rate?.symbol || "₹"}
                            {Number(item?.total_tax).toFixed(2)} /-
                          </span>
                        </div>
                      </>
                    )}
                    <div className="order-id">
                      <span>
                        <b className="user-name-holder">Grand Total</b>
                      </span>
                    </div>
                    <div className="text-highlight">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}
                        {Number(item?.total_amount).toFixed(2)} /-
                      </span>
                    </div>
                  </td>

                  <td>
                    <>
                      <div className="text-highlight">
                        <span>
                          {[
                            item?.User_Address?.first_name,
                            item?.User_Address?.last_name,
                          ]
                            .filter(Boolean)
                            .join(" ")}
                        </span>
                      </div>

                      <div className="order-info">
                        {[
                          item?.User_Address?.floor
                            ? `${item.User_Address.floor} floor`
                            : null,
                          item?.User_Address?.building,
                          item?.User_Address?.apartment,
                          item?.User_Address?.street,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </div>

                      <div className="order-info">
                        {[
                          item?.User_Address?.Users_Address_Detail?.Country
                            ?.name,
                          item?.User_Address?.Users_Address_Detail?.State?.name,
                          item?.User_Address?.Users_Address_Detail?.City?.name,
                          item?.User_Address?.Users_Address_Detail?.Area?.name,
                          item?.User_Address?.Users_Address_Detail?.Pincode
                            ?.name,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </div>

                      {item?.User_Address?.address_type && (
                        <div className="order-info">
                          <span>{item.User_Address.address_type}</span>
                        </div>
                      )}

                      {item?.User_Address?.contact_no && (
                        <div className="text-highlight">
                          <span>{item.User_Address.contact_no}</span>
                        </div>
                      )}
                    </>
                  </td>

                  <td>
                    {item?.order_status_id === 4 ? (
                      <div>
                        <p className="status-holder shipped">
                          {item?.Order_status?.name}
                        </p>
                      </div>
                    ) : (
                      <div>
                        <p className="status-holder Unshipped">
                          <b>{item?.Order_status?.name}</b>
                        </p>
                      </div>
                    )}
                  </td>

                  <td>
                    {item?.User?.deletedAt ? (
                      <div className="">
                        <div className="my-1">
                          <span className="text-danger fw-semibold ">
                            This order cannot be <br /> processed because the
                            <br />
                            customer account has <br /> been deleted.
                          </span>
                        </div>
                        <Button
                          className="action-btn active"
                          onClick={() =>
                            ChangeOrderStatus(
                              item?.id,
                              OrderStatusIds.Discarded,
                            )
                          }
                        >
                          Send Discarded
                        </Button>
                      </div>
                    ) : item?.order_status_id === OrderStatusIds.Pending ? (
                      <>
                        <div className="my-1">
                          <Button
                            className="action-btn active accept-btn-align"
                            onClick={() =>
                              ChangeOrderStatus(
                                item?.id,
                                OrderStatusIds.Processing,
                              )
                            }
                          >
                            Accept
                          </Button>
                        </div>
                      </>
                    ) : (
                      "-"
                    )}

                    <div className="my-1 mt-2">
                      <Button
                        className="action-btn danger"
                        onClick={() => {
                          setSelectedOrderId(item?.id);
                          setShowRemarkModal(true);
                        }}
                      >
                        Reject
                      </Button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
        {data && data?.data?.data?.length > 0 ? (
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        ) : (
          <p className="no-datashow">Sorry, No Data Found</p>
        )}
      </div>

      <ModalSave
        message={showModal2.message}
        showErrorModal={showModal2.code ? true : false}
      />

      <ProductModal
        handleClose={() => {
          setShowDetails({ show: 0, data: {} });
        }}
        setShow={() => setShowDetails({ show: 0, data: {} })}
        show={showDetails?.show}
        data={showDetails?.data}
      />
      <RemarkModal
        show={showRemarkModal}
        onHide={() => setShowRemarkModal(false)}
        title="Reject Order"
        submitText="Reject"
        onSubmit={handleRemarkSubmit}
      />
    </section>
  );
}

export default PendingOrdersTable;
